import type { ReactNode } from 'react';

export const symbol_wall_lamp: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M128.5-128.63Q120-137.25 120-150v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM307-500h426l-84-280H391l-84 280Zm0 0h426-426Zm-57 290q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h190q21.25 0 35.63-14.38Q490-298.75 490-320v-120H266q-15 0-24-12.5t-4-26.5l102-340q3-10 10.35-15.5 7.36-5.5 17.65-5.5h304q10.29 0 17.65 5.5Q697-829 700-819l102 340q5 14-4 26.5T774-440H550v120q0 45.83-32.08 77.92Q485.83-210 440-210H250Z"
		/>
	</svg>
);
